import { ExtendedNextLink } from 'components/Basic/ExtendedNextLink/ExtendedNextLink';
import Image from 'components/Basic/Image/Image';
import { B2bProductPrice } from 'components/Blocks/Product/Price/B2bProductPrice';
import ProductPrice from 'components/Blocks/Product/Price/ProductPrice';
import Checkbox from 'components/Forms/Checkbox/Checkbox';
import { useDomainConfig } from 'context/DomainConfigProvider/DomainConfigProvider';
import { isB2bDomain, isB2cDomain } from 'helpers/isDomainLocale';
import { useCurrentUserData } from 'hooks/user/useCurrentUserData';
import { twJoin } from 'tailwind-merge';
import { VirtualSetProductType } from 'types/product';

type VirtualSetProductProps = {
    product: VirtualSetProductType;
    isProductWantedInSet: boolean;
    onIsProductWantedToggle: (productUuid: string, isProductWanted: boolean) => void;
};

export const VirtualSetProduct: FC<VirtualSetProductProps> = ({
    product,
    isProductWantedInSet,
    onIsProductWantedToggle,
}) => {
    const domainConfig = useDomainConfig();
    const { isUserLoggedIn } = useCurrentUserData();
    const isActionPrice = product.price.priceWithoutVat < product.prices.basic.priceWithoutVat;

    return (
        <div
            className={twJoin(
                'flex w-full flex-1 cursor-pointer flex-col rounded-md border-2 border-gray px-2 py-4 md:w-[190px] md:min-w-[190px] md:max-w-[190px]',
                isProductWantedInSet ? '' : 'opacity-80 grayscale',
            )}
            onClick={() => onIsProductWantedToggle(product.uuid, !isProductWantedInSet)}
        >
            <Checkbox
                checked={isProductWantedInSet}
                className="flex cursor-pointer items-center p-3"
                label=""
                name={product.uuid}
                onClick={(event) => event.stopPropagation()}
            />
            <div className="flex h-full flex-col gap-y-3">
                <div className="flex justify-center">
                    <Image alt={product.name} height={100} src={product.image} width={100} />
                </div>
                <ExtendedNextLink
                    className="text-inherit no-underline"
                    href={product.slug}
                    type="product"
                    onClick={(event) => event.stopPropagation()}
                >
                    <span className="mt-2 font-medium">{product.name}</span>
                </ExtendedNextLink>
                <div className="mt-auto">
                    {isB2cDomain(domainConfig) && (
                        <div className="text-small">
                            {product.prices.tescoma && !isUserLoggedIn && (
                                <ProductPrice {...product.prices.tescoma} isTescomaPrice />
                            )}
                            {isActionPrice && <ProductPrice {...product.prices.basic} isOldPrice />}
                            <ProductPrice {...product.price} isActionPrice={isActionPrice} />
                        </div>
                    )}
                    {isB2bDomain(domainConfig) && (
                        <B2bProductPrice
                            b2bPaymentDiscount={product.b2bPaymentDiscount}
                            basePrice={product.prices.basic}
                            isUnitPrice={(product.b2bMinimumProductOrder ?? 0) > 1}
                            sellingPrice={product.price}
                            variant="list"
                        />
                    )}
                </div>
            </div>
        </div>
    );
};
